module.exports = __webpack_public_path__ + "static/media/fast-sportTextRU.149017c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/fast-sport/fast-sportTextRU.svg
// module id = 2460
// module chunks = 7